const CARD_TYPES = [
  { value: 'default', label: 'Default (Homepage)', params: [] },
  { value: 'game',    label: 'Game',    params: [
    { name: 'system', type: 'select', options: ['nes','snes','gb','gbc','gba','genesis','atari2600','c64'], default: 'nes' },
    { name: 'slug',   type: 'text', placeholder: 'e.g. super-mario-bros', default: 'super-mario-bros' },
  ]},
  { value: 'room',        label: 'Room',        params: [{ name: 'code', type: 'text', placeholder: 'Room code', default: '' }] },
  { value: 'user',        label: 'User',        params: [{ name: 'username', type: 'text', placeholder: 'Username', default: 'banyan' }] },
  { value: 'invite',      label: 'Invite',      params: [{ name: 'token', type: 'text', placeholder: 'Invite token', default: '' }] },
  { value: 'leaderboard', label: 'Leaderboard', params: [{ name: 'gameId', type: 'text', placeholder: 'Game ID (number)', default: '4057' }] },
  { value: 'top100',      label: 'Top 100',     params: [
    { name: 'system', type: 'select', options: ['nes','snes','gb','gbc','gba','genesis','atari2600','c64'], default: 'nes' },
  ]},
  { value: 'library',        label: 'Library (Browse)',  url: '/api/og-image/default', params: [] },
  { value: 'library-lists',  label: 'Library Lists',     url: '/api/og-image/default', params: [] },
  { value: 'library-public', label: 'Library Public Lists', url: '/api/og-image/default', params: [] },
  { value: 'library-game',   label: 'Library Game',      url: '/api/og-image/game', params: [
    { name: 'system', type: 'select', options: ['nes','snes','gb','gbc','gba','genesis','atari2600','c64'], default: 'nes' },
    { name: 'slug',   type: 'text', placeholder: 'e.g. super-mario-bros', default: 'super-mario-bros' },
  ]},
];

let _rendered = false;

export async function render() {
  if (_rendered) return;
  _rendered = true;

  const container = document.getElementById('og-preview-content');
  if (!container) return;

  const typeSelect = document.createElement('select');
  typeSelect.className = 'admin-select';
  typeSelect.style.cssText = 'margin-bottom:12px; min-width:180px';
  for (const t of CARD_TYPES) {
    const opt = document.createElement('option');
    opt.value = t.value;
    opt.textContent = t.label;
    typeSelect.appendChild(opt);
  }

  const paramsRow = document.createElement('div');
  paramsRow.style.cssText = 'display:flex; gap:8px; align-items:center; flex-wrap:wrap; margin-bottom:16px';

  const renderBtn = document.createElement('button');
  renderBtn.className = 'btn';
  renderBtn.textContent = 'Render';

  const controls = document.createElement('div');
  controls.style.cssText = 'display:flex; gap:8px; align-items:center; flex-wrap:wrap; margin-bottom:16px';
  controls.append(typeSelect, paramsRow, renderBtn);

  // Preview area — social size
  const previewLabel = document.createElement('div');
  previewLabel.style.cssText = 'font-size:11px; opacity:0.5; margin-bottom:4px';
  previewLabel.textContent = 'SOCIAL PREVIEW (scaled)';

  const img = document.createElement('img');
  img.style.cssText = 'width:100%; max-width:600px; border-radius:8px; border:1px solid var(--border, #333); display:none';

  // Full-res area
  const fullLabel = document.createElement('div');
  fullLabel.style.cssText = 'font-size:11px; opacity:0.5; margin:16px 0 4px';
  fullLabel.textContent = 'FULL RESOLUTION (1200 × 630)';

  const fullImg = document.createElement('img');
  fullImg.style.cssText = 'width:1200px; max-width:100%; border-radius:4px; border:1px solid var(--border, #333); display:none';

  const status = document.createElement('div');
  status.style.cssText = 'font-size:12px; margin-top:4px; margin-bottom:12px';

  container.append(controls, status, previewLabel, img, fullLabel, fullImg);

  function buildUrl() {
    const type = CARD_TYPES.find(t => t.value === typeSelect.value);
    if (!type) return null;
    const inputs = paramsRow.querySelectorAll('[data-param]');
    const base = type.url || `/api/og-image/${type.value}`;
    const parts = [base];
    for (const input of inputs) {
      const val = (input.value || '').trim();
      if (!val) return null;
      parts.push(encodeURIComponent(val));
    }
    return parts.join('/');
  }

  function renderParams() {
    paramsRow.innerHTML = '';
    img.style.display = 'none';
    fullImg.style.display = 'none';
    previewLabel.style.display = 'none';
    fullLabel.style.display = 'none';
    status.textContent = '';
    const type = CARD_TYPES.find(t => t.value === typeSelect.value);
    if (!type) return;
    for (const p of type.params) {
      if (p.type === 'select') {
        const sel = document.createElement('select');
        sel.className = 'admin-select';
        sel.dataset.param = p.name;
        for (const o of p.options) {
          const opt = document.createElement('option');
          opt.value = o;
          opt.textContent = o.toUpperCase();
          if (o === p.default) opt.selected = true;
          sel.appendChild(opt);
        }
        paramsRow.appendChild(sel);
      } else {
        const inp = document.createElement('input');
        inp.type = 'text';
        inp.placeholder = p.placeholder || p.name;
        inp.value = p.default || '';
        inp.dataset.param = p.name;
        inp.style.cssText = 'padding:6px 10px; border-radius:4px; border:1px solid var(--border, #333); background:var(--surface, #222); color:var(--text, #eee); font-size:13px; min-width:160px';
        inp.addEventListener('keydown', e => { if (e.key === 'Enter') doRender(); });
        paramsRow.appendChild(inp);
      }
    }
    doRender();
  }

  function doRender() {
    const url = buildUrl();
    if (!url) {
      status.textContent = 'Fill in all parameters';
      status.style.color = '#ff4060';
      img.style.display = 'none';
      fullImg.style.display = 'none';
      previewLabel.style.display = 'none';
      fullLabel.style.display = 'none';
      return;
    }
    status.style.color = '';
    const cacheBust = `${url}${url.includes('?') ? '&' : '?'}t=${Date.now()}`;
    status.textContent = 'Rendering…';
    img.style.display = 'none';
    fullImg.style.display = 'none';
    const t0 = performance.now();
    img.onload = () => {
      const ms = Math.round(performance.now() - t0);
      status.textContent = `Rendered in ${ms}ms · ${url}`;
      img.style.display = 'block';
      previewLabel.style.display = '';
      fullImg.src = cacheBust;
      fullImg.style.display = 'block';
      fullLabel.style.display = '';
    };
    img.onerror = () => {
      status.textContent = `Failed to load ${url}`;
      img.style.display = 'none';
      fullImg.style.display = 'none';
    };
    img.src = cacheBust;
  }

  typeSelect.addEventListener('change', renderParams);
  renderBtn.addEventListener('click', doRender);

  renderParams();
  // Auto-render the default card
  doRender();
}
